import { render, staticRenderFns } from "./VueTextAnnotation1.vue?vue&type=template&id=9e09c5e4&"
import script from "./VueTextAnnotation1.vue?vue&type=script&lang=js&"
export * from "./VueTextAnnotation1.vue?vue&type=script&lang=js&"
import style0 from "./VueTextAnnotation1.vue?vue&type=style&index=0&id=9e09c5e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports